import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var name = 'item';
export default {
  name: 'd2-search-panel',
  props: {
    value: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function data() {
    return {
      name: name,
      active: ''
    };
  },
  watch: {
    value: {
      handler: function handler(value) {
        this.active = value ? this.name : '';
      },
      immediate: true
    }
  },
  computed: {
    buttonIcon: function buttonIcon() {
      return this.active === this.name ? 'el-icon-caret-top' : 'el-icon-caret-bottom';
    },
    buttonLabel: function buttonLabel() {
      return this.active === this.name ? 'hide' : 'show';
    },
    hasPrefixSlot: function hasPrefixSlot() {
      return !!this.$slots.prefix;
    },
    hasTitleSlot: function hasTitleSlot() {
      return !!this.$slots.title;
    },
    hasContentSlot: function hasContentSlot() {
      return !!this.$slots.default;
    }
  },
  methods: {
    onItemClick: function onItemClick() {},
    toggle: function toggle() {
      if (this.active) {
        this.active = '';
        this.$emit('input', false);
      } else {
        this.active = this.name;
        this.$emit('input', true);
      }
    }
  }
};